import { validateRussianSNILS, type FormConfig } from '@acme/foundation';

export const personalInfoFormConfig = (
  includeUnchangedFields: boolean = true
): FormConfig => ({
  id: 'personal-info-form',
  includeUnchangedFields,
  controls: [
    {
      id: 'person.name',
      label: 'ФИО пользователя',
      type: 'text',
      read: (ctx: any) => ctx?.person?.name || '',
      write: { path: 'person.name' },
      props: {
        placeholder: 'Введите ФИО',
      },
    },
    {
      id: 'person.snils',
      label: 'СНИЛС',
      type: 'text',
      read: (ctx: any) => ctx?.person?.snils || '',
      write: { path: 'person.snils' },
      validation: (value: unknown) =>
        validateRussianSNILS(typeof value === 'string' ? value : ''),
      props: {
        placeholder: 'Введите СНИЛС',
      },
    },

    {
      id: 'person.passport.issued',
      label: 'Кем выдан паспорт',
      type: 'text',
      read: (ctx: any) => ctx?.person?.passport?.issued || '',
      write: { path: 'person.passport.issued' },
      props: {
        placeholder: 'Введите кем выдан паспорт',
      },
    },
    {
      id: 'person.title',
      label: 'Должность',
      type: 'text',
      read: (ctx: any) => ctx?.person?.title || '',
      write: { path: 'person.title' },
      props: {
        placeholder: 'Введите должность',
      },
    },
    {
      id: 'person.email',
      label: 'Эл. почта',
      type: 'text',
      read: (ctx: any) => ctx?.person?.email || '',
      write: { path: 'person.email' },
      props: {
        placeholder: 'Введите email',
      },
    },
    {
      id: 'person.phoneNumber',
      label: 'Телефон',
      type: 'text',
      read: (ctx: any) => ctx?.person?.phoneNumber || '',
      write: { path: 'person.phoneNumber' },
      props: {
        placeholder: 'Введите номер телефона',
      },
    },
  ],
});
